import bowlWithWiskIcon from 'src/assets/svg/shef/bowl-with-whisk.svg';
import shefLocationIcon from 'src/assets/svg/shef/shef-location.svg';
import starIcon from 'src/assets/svg/shef/squiggly-star.svg';
import { ScrollSnapCarousel } from 'src/pages/components/ScrollSnapCarousel';
import { LayoutContainer } from './LayoutContainer';

const REVIEW_DATA = [
  {
    shefName: 'Ketevan',
    numberOfOrders: '176',
    reviewText:
      'Everything is WOW. I feel like my life got richer with these items to nibble on in my fridge throughout the week. This is the ultimate comfort food.',
    shefImageUrl: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/shef_images/ketevan.png',
    reviewerName: 'Margarita Korol',
    reviewerLocation: 'New York',
  },
  {
    shefName: 'Issara',
    numberOfOrders: '2k+',
    reviewText:
      "I will DEFINITELY keep my subscriptions. The food tastes like it came directly from a mother's kitchen. AMAZING!",
    shefImageUrl: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/shef_images/issara.png',
    reviewerName: 'Nancy E.',
    reviewerLocation: 'Bay Area',
  },
  {
    shefName: 'Brandon',
    numberOfOrders: '223',
    reviewText:
      'I just had the most amazing food delivered to my home! It tasted so good and felt just like homemade cooking!',
    shefImageUrl: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/shef_images/brandon.png',
    reviewerName: 'Purna P.',
    reviewerLocation: 'Chicago',
  },
  {
    shefName: 'Seema',
    numberOfOrders: '4k+',
    reviewText: 'The food tastes absolutely amazing, is delivered with love, and feels like home.',
    shefImageUrl: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/shef_images/seema.png',
    reviewerName: 'Medha A.',
    reviewerLocation: 'Seattle',
  },
  {
    shefName: 'Jyoti',
    numberOfOrders: '127',
    reviewText: "Delicious food. Reminded me of my mom's food. I will definitely order again. Thank you so much.",
    shefImageUrl: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/shef_images/jyoti.png',
    reviewerName: 'Anukool R.',
    reviewerLocation: 'Chicago',
  },
  {
    shefName: 'Rosie',
    numberOfOrders: '1k+',
    reviewText:
      'What an amazing meal plan they offer! The packaging and ingredients everything is just excellent. Definitely makes you feel like home. Thank you!',
    shefImageUrl: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/shef_images/rosie.png',
    reviewerName: 'Dhun R.',
    reviewerLocation: 'Chicago',
  },
  {
    shefName: 'Gary',
    numberOfOrders: '8',
    reviewText:
      "I was blown away by the food. Better than NYC restaurants. Certainly better than any other weekly food delivery service and I've used several.",
    shefImageUrl: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/shef_images/gary.png',
    reviewerName: 'Eileen T.',
    reviewerLocation: 'New york',
  },
  {
    shefName: 'Latoya',
    numberOfOrders: 597,
    reviewText: `It's like a most loving relative filling your fridge with homemade meals. Everything is so delicious! You can feel the care and love. 100% recommend!`,
    shefImageUrl: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/shef_images/latoya.png',
    reviewerName: 'Dhun R.',
    reviewerLocation: 'Chicago',
  },
];

const Rating = () => (
  <div className='flex items-center space-x-1'>
    <img src={starIcon} alt='Star' />
    <img src={starIcon} alt='Star' />
    <img src={starIcon} alt='Star' />
    <img src={starIcon} alt='Star' />
    <img src={starIcon} alt='Star' />
  </div>
);

const ReviewCard = ({ shefName, numberOfOrders, shefImageUrl, reviewText, reviewerName, reviewerLocation }) => (
  <div>
    <div className='relative mx-1 flex h-[340px] max-h-full min-h-full w-[300px] flex-col items-center justify-between rounded-lg bg-white p-4 px-2.5 pt-[9px]'>
      <div className='absolute right-3 top-2'>
        <div className='inline-flex items-center justify-start rounded bg-rice pb-1 pl-[5px] pr-1.5 pt-[3px] text-xs font-semibold text-neutral-800 shadow-none'>
          <div className='mx-1'>
            <img src={bowlWithWiskIcon} />
          </div>
          <p className='mr-1'>{numberOfOrders} Orders</p>
        </div>
      </div>
      <div>
        <div className='bg-gray-200 flex items-center justify-center rounded-full'>
          <img src={shefImageUrl} alt='Shef' />
        </div>
        <div className='flex flex-col items-center'>
          <h2 className='mt-4 text-xl font-bold text-raspberry'>
            Shef <span className='font-quick-writers'>{shefName}</span>
          </h2>
          <Rating />
          <p className='mt-2 px-4 text-center text-sm text-eggplant'>{reviewText}</p>
        </div>
      </div>

      <div>
        <div className='mt-4 flex flex-col items-center justify-end space-x-2 font-quick-writers text-base'>
          <p>{reviewerName}</p>
        </div>
        <div className='align-start mt-2 flex justify-center gap-1'>
          <img src={shefLocationIcon} />
          <p className='text-xs'>{reviewerLocation}</p>
        </div>
      </div>
    </div>
  </div>
);

export const ReviewsSection = () => (
  <div className='flex flex-col justify-center bg-rice py-16'>
    <LayoutContainer className='mb-11 flex justify-center lg:mb-[4rem]'>
      <h1 className='text-center text-[50px] font-extrabold uppercase text-eggplant'>Compliments to the Shefs</h1>
    </LayoutContainer>
    <div className='mr-3'>
      <ScrollSnapCarousel hideScrollButtons addLeftMargin showSideGradients={false}>
        {REVIEW_DATA.map((review) => (
          <ReviewCard key={review.shefName} {...review} />
        ))}
      </ScrollSnapCarousel>
    </div>
  </div>
);
